// extracted by mini-css-extract-plugin
export default {"plusMinusWidget":"style_plusMinusWidget__fIc+C","counter":"style_counter__wsEKB","small":"style_small__0XS9Z"};